<template>
    <div class="risk-tip">
        <div class="bar-pad">
            <p class="line">
                <i class="fa fa-exclamation-triangle"></i>风险提示：
            </p>
            <p class="tip">
                投资本基金存在发生本金损失的风险，请谨慎决策。基金管理人不保证本基金一定盈利，也不保证最低收益。投资者在购买本基金前应仔细阅读《基金合同》、《招募说明书》、《产品资料概要》等法律文件，了解本基金风险收益特征，并根据自身投资目的、投资经验、投资期限、财务状况等判断本基金是否与您风险承受能力相适应。
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "RiskTip"
};
</script>

<style scoped>
    .risk-tip{
        margin-left:162px;
    }
    .bar-pad{
        color: GrayText;
        margin: 16px 16px;
        text-align: justify;
    }
    .fa-exclamation-triangle{
        color: greenyellow;
    }
    .line{
        line-height: 26px;
    }
    .tip{
        line-height: 26px;
        margin-right: 368px;
        text-indent: 2em;
    }
</style>
